import { Space } from 'antd';

import styles from './Image.module.scss';

export enum HeaderType {
    TODO = 'todo',
    DOING = 'doing',
    REPORT = 'report',
    SETTING = 'setting',
}

interface Props {
    type: HeaderType;
    value?: string;
}

export const HeaderImage = ({ type, value }: Props) => {
    const classes = [];
    if (type == HeaderType.TODO) {
        classes.push(styles.todo);
    } else if (type == HeaderType.DOING) {
        classes.push(styles.doing);
    } else if (type == HeaderType.REPORT) {
        classes.push(styles.report);
    } else if (type == HeaderType.SETTING) {
        classes.push(styles.setting);
    } else {
        classes.push(styles.default);
    }

    return (
        <span className={styles.header}>
            <Space direction="vertical" align="center" wrap>
                <img title="header" className={classes.join(' ')} />
                <span className={styles.description}>{value}</span>
            </Space>
        </span>
    );
};
